export enum Scroll {
  CONTENT = 'content',
  VIEWPORT = 'viewport',
}

export type ScrollContent = 'content';
export type ScrollViewport = 'viewport';
